import useGlobalSpinner from "@/context/spinner";
import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";

const GlobalSpinner: React.FC = () => {
    const loading = useGlobalSpinner(state => state.loading);

    return (
        <Backdrop sx={theme => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })} open={loading}>
            <CircularProgress color="primary" />
        </Backdrop>
    );
};

export default GlobalSpinner;
